import { baseUrl } from "../../../config.js";
import { EventBus } from "../../../eventbus.js";
import { errorDispatch } from "../../../functions/errorDispatch.js";
import { setDocTitle } from "../../../functions/HelperFuncs.js";

export default {
  data() {
    return {
      id: this.$options.name,
      collectionId: this.$route.params.id,
      collectionName: "",
      collectionData: null,
      files: [],
      selectedFiles: [],
      doneSearching: false,
    };
  },
  beforeMount() {
    //check if mobile
    this.redirect();
  },
  created() {
    //set title
    setDocTitle("collectionDetail", this);

    //get collecion name
    this.setCollectionName();

    //get files()
    this.getFiles();

    EventBus.$on(`files-holder-update`, (data) => {
      //update selected files and folders

      Object.keys(data).forEach((key) => {
        if (data[key] && this[key]) {
          this[key] = data[key];
        }
      });
    });

    EventBus.$on(`${this.id}-update`, () => {
      this.getFiles();
    });
  },

  methods: {
    setCollectionName() {},
    removeFilesFromCollection() {
      const formData = new FormData();
      formData.append("files", JSON.stringify(this.selectedFiles));
      formData.append("collection", this.collectionId);

      this.$axios
        .post(baseUrl + "/collectiondeletefiles", formData)
        .then((r) => {
          //get updated files
          this.getFiles();
        });
    },
    getFiles() {
      this.doneSearching = false;

      this.$axios
        .get(`${baseUrl}/collection/${this.collectionId}`)
        .then((r) => {
          if (r.data) {
            this.files = r.data.items;
            this.collectionName = r.data.collectionData.name;

            this.collectionData = r.data.collectionData;

            //set title
            setDocTitle(this.collectionName, this);
          } else {
            this.files = [];
          }

          this.doneSearching = true;
        })
        .catch((e) => {
          errorDispatch("find_collection");
        });
    },
    redirect() {
      if (!this.$store.state.isMobile) {
        //is desktop so go to collections
        this.$router.replace(`/${this.$store.state.company}/collections`);
      }
    },
  },
};
